let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jVUfy")).then(() => parcelRequire('2N2w4'));